import { translate } from '../i18n'
import { EqualsToValidator } from './EqualsToValidator'

export class ConfirmPasswordValidator extends EqualsToValidator {
    constructor(supplier: () => string) {
        super(supplier, translate('validations.confirm_password') as string)
    }
}
